module.exports = __webpack_public_path__ + "img/product-shot_04.abb30daf.jpg";